<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.pa-0
    div.px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('template').toLowerCase() }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('template').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="loading" color="danger500" depressed dark @click="onConfirm") {{ $t('confirm') }}
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onConfirm () {
      this.$emit('delete')
      this.showDialog = false
    }
  }
}
</script>